import { uniq } from 'lodash'
import type { z } from 'zod'
import { apiPriorArtSchema } from './prior-art'

export type { BasePriorArt as ApiPatent } from './prior-art'

export const apiPatentSchema = apiPriorArtSchema

export const patentSchema = apiPatentSchema
  .omit({ family_members: true })
  .transform((patent) => {
    const {
      application_date,
      application_number,
      backward_citations,
      cpc_subclass,
      cpc_symbols,
      current_assignees,
      current_owners,
      is_npl,
      document_number,
      family_id,
      forward_citations,
      google_document_number,
      legal_status,
      priority_date,
      projected_expiration_date,
      publication_date,
      image_paths,
      is_licensed,
      is_litigated,
      ...patentFields
    } = patent

    return {
      ...patentFields,
      applicationNumber: application_number,
      applicationDate: application_date,
      backwardCitations: backward_citations,
      cpcSubclass: cpc_subclass,
      cpcSymbols: cpc_symbols,
      currentAssignees: uniq([...current_assignees, ...current_owners]),
      isNpl: is_npl,
      documentNumber: document_number,
      familyId: family_id,
      forwardCitations: forward_citations,
      googleDocumentNumber: google_document_number,
      legalStatus: legal_status,
      priorityDate: priority_date,
      projectedExpirationDate: projected_expiration_date,
      publicationDate: publication_date,
      imagePaths: image_paths,
      isLicensed: is_licensed,
      isLitigated: is_litigated,
    }
  })

export type Patent = z.infer<typeof patentSchema>
